import './grouped-product-thumbs.scss';

$('.grouped-product-thumbs').each(function () {
    let $this = $(this);

    $this.find('.grouped-product-thumbs__tabs').on('change', function (e, i) {
        $this.find('.grouped-product-thumbs__tabs-slider').get(0).swiper.slideTo(i);
    });
});